// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"32ccc2af","129":"da111878","327":"026bdfcb","444":"3d4e2a9e","544":"ec676667","649":"ce499338","868":"063ceb34","940":"0fc611a0","941":"2a2359e0"}[chunkId] + ".chunk.js";
};